import React from "react";

const ShowCompanyForm = ({ company, closeModal }) => {
  if (!company || !company.form || !company.form.fields) {
    return <p>No form available for this company.</p>;
  }

  const { fields } = company.form;

  return (
    <div className="w-96">
      <h2 className="text-2xl font-semibold text-gray-900 mb-4">
        {company?.name} - Form
      </h2>
      <form className="space-y-4">
        {fields.map((field, index) => {
          switch (field.type) {
            case "text":
            case "email":
            case "number":
              return (
                <div key={index}>
                  <label
                    className="block mb-2 font-semibold"
                    htmlFor={field.name}
                  >
                    {field.label}
                  </label>
                  <input
                    type={field.type}
                    name={field.name}
                    placeholder={field.placeholder}
                    className="w-full p-2 border border-gray-300 rounded"
                  />
                </div>
              );

            case "dropdown":
              return (
                <div key={index}>
                  <label
                    className="block mb-2 font-semibold"
                    htmlFor={field.name}
                  >
                    {field.label}
                  </label>
                  <select
                    name={field.name}
                    className="w-full p-2 border border-gray-300 rounded"
                  >
                    {field.options.map((option, optIndex) => (
                      <option key={optIndex} value={option}>
                        {option}
                      </option>
                    ))}
                  </select>
                </div>
              );

            default:
              return (
                <div key={index}>
                  <p>Unsupported field type: {field.type}</p>
                </div>
              );
          }
        })}
      </form>
      <div className="flex gap-2 justify-center mt-4">
        <button
          className="px-4 py-2 rounded-lg w-full shadow-md hover:-translate-y-1 transition-all hover:shadow-lg active:translate-y-0 active:shadow bg-white text-gray-500 border border-slate-300"
          onClick={closeModal}
        >
          Cancel
        </button>
      </div>
    </div>
  );
};

export default ShowCompanyForm;
